import gql from 'graphql-tag';

import listingQuery from './listingQuery';
import favoriteIdsQuery from './favoriteIdsQuery';
import listingStatistics from './listingStatistics';
import citiesQuery from './citiesQuery';
import internalLinkingQuery from './internalLinkingQuery';
import landlordHomecarsQuery from './landlordHomecarsQuery';
import seoQuery from './seoQuery';

const QUERY_LISTING_PROPERTY_RULES = gql`
  query Listing($id: ID!, $locale: String!) {
    listing(id: $id, locale: $locale) {      
      ${seoQuery}
      ${listingQuery}
      ${citiesQuery}
      ${internalLinkingQuery}
      ${landlordHomecarsQuery}
      areaSlug
      isRoomsAggregator
    }
    ${favoriteIdsQuery}
    ${listingStatistics}
    isLogged
  }
`;

export const getListing = client => (id, locale) =>
  client.query({
    query: QUERY_LISTING_PROPERTY_RULES,
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
    variables: {
      id,
      locale
    }
  });

const QUERY_LAST_UNPUBLISHED_DATE = gql`
  query LastUnpublishedDate($id: ID!) {
    ad(id: $id) {
      lastUnpublishedDate
    }
  }
`;

export const getLastUnpublishedDate = client => id =>
  client.query({
    query: QUERY_LAST_UNPUBLISHED_DATE,
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
    variables: { id }
  });

export default {
  getListing
};
